import React, { FC, useEffect, useState } from "react";
import Animated, { Easing, useAnimatedStyle, withTiming } from "react-native-reanimated";
import { View } from "@lookiero/aurora";
import { DoubleHalf } from "./DoubleHalf";
import { Rectangle } from "./Rectangle";
import { style } from "./Shape.styles";

type ShapeType = "doubleHalf" | "rectangle";

interface ShapeProps {
  readonly type: ShapeType;
}

const animationConfig = {
  duration: 1000,
  easing: Easing.inOut(Easing.cubic),
};
const SHAPE_ANIMATION_DELTA_Y = 60;
const BANNER_HEIGHT = 309;
const BANNER_WIDTH = 240;

const Shape: FC<ShapeProps> = ({ type }) => {
  const [visible, setVisible] = useState(false);
  const deltaY = type === "doubleHalf" ? SHAPE_ANIMATION_DELTA_Y : -SHAPE_ANIMATION_DELTA_Y;
  const ShapeComponent = type === "doubleHalf" ? DoubleHalf : Rectangle;

  const animatedStyle = useAnimatedStyle(
    () => ({
      opacity: withTiming(visible ? 1 : 0, animationConfig),
      transform: [{ translateY: withTiming(visible ? 0 : deltaY, animationConfig) }],
    }),
    [deltaY, visible],
  );

  useEffect(() => setVisible(true), []);

  return (
    <View style={style.shapeContainer}>
      <Animated.View style={[style.shape, style[type], animatedStyle]}>
        <ShapeComponent height={BANNER_HEIGHT} width={BANNER_WIDTH} />
      </Animated.View>
    </View>
  );
};

export { Shape };
